import styled from 'styled-components';
import { Z_INDEXES, getColor, getColorShade, getSizeBy, getThemeProp } from '@invent/wl-ui-kit';
import type { ThemeColor } from '@invent/shared-types';

export const Wrapper = styled.div<{ $backgroundColor: ThemeColor }>`
  z-index: ${Z_INDEXES.LIGHTBOX};
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100% - ${getSizeBy(3)});
  height: calc(100% - ${getSizeBy(3)});
  margin: auto;
  background-color: ${({ $backgroundColor }) => getColor($backgroundColor)};
  border: 0.5px solid ${getColorShade('onSurface', 'outline')};
  border-radius: ${getThemeProp('widgetsBorderRadius')}px;
  cursor: pointer;
`;
